import { OI } from "../onam/mark";
import { FEATURES } from "../onam/features";
const BaseSimplePlusIcon = ({
  color = `var(--Primary-Color-Shade-1)`,
  size = 12,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 11V1M1 6H11"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

/* With the ONAM skin (FEATURES.curationSkin) this draws ONAM's "add" glyph instead (onam/mark.tsx). */
const SimplePlusIconSkin = (props: any) =>
  FEATURES.curationSkin ? (
    <OI n="add" size={props.size || 16} className={props.className} style={props.style} onClick={props.onClick} title={props.title} color={props.color}
      onMouseOver={props.onMouseOver} onMouseOut={props.onMouseOut} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave} />
  ) : (
    <BaseSimplePlusIcon {...props} />
  );
export default SimplePlusIconSkin;
